import { inventorySlotQueryKeys as e } from "./useInventorySlotQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { inventorySlotsApi as n } from "@maat/api-main";
//#region src/inventorySlots/useSlotListingDetailQuery.ts
var r = (r, i = {}) => t({
	queryKey: e.listingDetail(r),
	queryFn: () => n.getSlotListingDetail(r),
	enabled: !!r && i.enabled !== !1
});
//#endregion
export { r as useSlotListingDetailQuery };
